import Quill from 'quill'
import Renderer from './renderer'
import util from '../util'
import Text from './text'
import {setLineHeights} from "./line-height";

const Clipboard = Quill.import('modules/clipboard')
const Delta = Quill.import('delta')

const ALLOWED_TAGS = ['P', 'SPAN', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
const TYPE = 'delta'

class CustomClipboard extends Clipboard {
    domReplace(e) {
        const $target = $(e.target)
        const $element = $target.parents('[data-component="text"]');
        const $page = $target.parents('[data-component="page"]');
        const $editor = $element.find('.ql-editor');
        const $elements = $(e.clipboardData.getData('text/html'));

        $editor.html('');
        $elements.each(function () {
            const $bit = $(this);
            if (ALLOWED_TAGS.indexOf($bit.prop('tagName')) > -1) {
                const $sanitized = Text.sanitizeParagraph(util.asParagraph($bit), $page, true);
                $editor.append($sanitized);
            }
        });

        util.nextTick(() => {
            $element.find('p').each(function () {
                const $p = $(this);
                $p.css('font-size', $p.attr('data-font-size'));
                $p.attr('data-font-size', '');
            });

            setLineHeights($element);
            const $group = $target.parents('[data-component="group"]');
            if ($group.length > 0) {
                Renderer.ensureGroupDimensions($element);
            }
        })
    }

    deltaReplace(e) {
        const range = this.quill.getSelection();
        let txt = e.clipboardData.getData('text/plain');
        txt = util.stripDoubleNewLine(txt);
        const format = this.quill.getFormat(range.index, 1);

        const delta = new Delta()
            .retain(range.index)
            .delete(range.length)
            .insert(txt, format);
        this.quill.updateContents(delta, 'silent');

        const index = txt.length + range.index;
        this.quill.setSelection(index, 0, 'silent');

        this.quill.scrollIntoView();
    }

    onPaste(e) {
        e.stopPropagation();
        e.preventDefault();

        if (TYPE === 'delta') {
            this.deltaReplace(e);
        } else {
            this.domReplace(e);
        }
    }
}

export default CustomClipboard
